import { all } from "redux-saga/effects";
// import { initializeWebSocket } from "./socketSaga";
import { watchAuthRequest } from "./authSaga";
import { watchCheckinRequest } from "./checkinSaga";
import { watchReservationRequest } from "./reservationSaga";
import { watchRentalRequest } from "./rentalSaga";
import { watchVirRequest } from "./virSaga";
import { watchRentalManageRequest } from "./rentalManageSaga";

export default function* rootSaga(/* dispatch */) {
  yield all([
    // initializeWebSocket(dispatch),
    watchAuthRequest(),
    watchCheckinRequest(),
    watchReservationRequest(),
    watchRentalRequest(),
    watchVirRequest(),
    watchRentalManageRequest(),
  ]);
}
